import {
	EmailOutlineIcon,
	FacebookMessengerIcon,
	FacebookRegularIcon,
	InstagramIcon,
	NextDoorIcon,
	TextSmsIcon,
	TwitterIcon,
	WhatsAppIcon,
} from '@change/ds-icons';

export const CHANNEL_META = {
	facebook: {
		Icon: FacebookRegularIcon,
		className: 'bg-[#1877F2] text-icon-inverse-strong',
	},
	instagram: {
		Icon: InstagramIcon,
		className:
			'bg-[linear-gradient(45deg,_#FFD521_14.64%,_#FFD020_18.54%,_#FEC01E_23.42%,_#FCA71B_28.82%,_#FA8316_34.59%,_#F85510_40.67%,_#F51E09_46.91%,_#F30005_50%,_#F20007_50.25%,_#E1003B_56.83%,_#D30067_63.29%,_#C70088_69.49%,_#BF00A0_75.38%,_#BB00AF_80.81%,_#B900B4_85.36%)] text-icon-inverse-strong',
	},
	whatsapp: {
		Icon: WhatsAppIcon,
		className: 'bg-[#25D366] text-icon-inverse-strong',
	},
	nextdoor: {
		Icon: NextDoorIcon,
		className: 'bg-[#8ED500] text-icon-inverse-strong',
	},
	twitter: {
		Icon: TwitterIcon,
		className: 'bg-fill-strong text-icon-inverse-strong',
	},
	facebookMessenger: {
		Icon: FacebookMessengerIcon,
		className: 'bg-[#0080F7] text-icon-inverse-strong',
	},
	email: {
		Icon: EmailOutlineIcon,
		className: 'bg-fill-weaker text-icon-strong',
	},
	sms: {
		Icon: TextSmsIcon,
		className: 'bg-fill-weaker text-icon-strong',
	},
} as const;

export const SUPPORTED_CHANNELS = [
	'facebook',
	'instagram',
	'whatsapp',
	'nextdoor',
	'twitter',
	'facebookMessenger',
	'email',
	'sms',
];
